import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import FloatingCTA from "../components/FloatingCTA";
import ProductMarketplace from "../components/ProductMarketplace";
import { ArrowUp } from "lucide-react";

export default function Products() {
  const [scrolled, setScrolled] = useState(false);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
      setShowTop(window.scrollY > 500);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#07090e] text-slate-100 flex flex-col justify-between selection:bg-red-500 selection:text-white">
      <Header scrolled={scrolled} />
      <main className="flex-grow pt-28 pb-20">
        <ProductMarketplace embedded={false} />
      </main>
      <Footer />
      <ContactModal />
      <FloatingCTA />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="scroll-top-btn"
          className="fixed left-4 bottom-6 z-40 w-11 h-11 bg-[#E63946] hover:bg-[#d22c39] text-white rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(230,57,70,0.4)] transition-all hover:scale-110"
          aria-label="Nach oben"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
}
